import TicketUpload from './TicketUpload'

export default TicketUpload
